import { computed } from 'vue'
import { useVoiceBotsStore } from '@voicenter-team/events-sdk-vue-3'
import type { Voicebot } from '@voicenter-team/events-sdk-vue-3'

const voiceBotsStore = useVoiceBotsStore()

export function useVoiceBotsState () {
    const allBots = computed(() => voiceBotsStore.voiceBotsListAll.value as Voicebot[])

    return {
        allBotsWithCalls: allBots
    }
}
